import React from "react";

import { Text, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  badge: {
    backgroundColor: "#eef2f6",
    color: "#2b3e54",
    padding: "1mm",
    borderRadius: "5pt",
  },
});

type BadgeProps = {
  label: string;
};

const Badge: React.FC<BadgeProps> = ({ label }) => (
  <Text style={styles.badge}>{label}</Text>
);

export default Badge;
